<template>
	<header :class="{ 'header-blue' : headerBlue || isActiveHambur }">
	<!-- <header> -->
		<div class="header-container">
			<burger-button :active="isActiveHambur" @click="$store.dispatch('actualizarMenuOpened', !isActiveHambur)" class="hambur-menu" />
			<router-link class="logo" :to="{ name: 'home' }">
				<img src="@/assets/logo.svg" alt="Nacional Tickets">
				<!-- <img src="@/assets/logo-sm.png" alt="Nacional Tickets"> -->
				<span>Club Nacional de Football</span>
			</router-link>
			<nav class="menu">
				<div class="menu-item"><router-link :to="{ name: 'home' }" class="active">Inicio</router-link></div>
				<div class="menu-item"><a href="https://nacional.uy/es/media/multimedia/video/hwXDlZtfOvmm8xXixwNHPV3RKscDX4ER" target="_blank">¿Cómo funciona?<external-link-icon></external-link-icon></a></div>
				<div class="menu-item"><router-link :to="{ name: 'espectaculos' }">Espectáculos</router-link></div>
				<div class="menu-item"><router-link :to="{ name: 'paseos-gpc' }">Paseo del GPC</router-link></div>
				<div class="menu-item"><router-link :to="{ name: 'mis-entradas' }">Mis entradas</router-link></div>
				<div class="menu-item"><a href="https://www.nacional.uy/" target="_blank">Nacional.uy<external-link-icon></external-link-icon></a></div>
			</nav>
			<div class="user-menu">
				<div class="user-menu-item login-item" v-if="!loggedIn">
					<!-- <router-link :to="{ name: 'login' }">Entrar</router-link> -->
					<a :href="urlLoginNacional">Entrar</a>
				</div>
				<div class="user-menu-item login-item-mobile" v-if="!loggedIn">
					<router-link :to="{ name: 'login' }"><user-icon></user-icon></router-link>
				</div>
				<div class="user-menu-item user-menu-item-cuenta" v-if="loggedIn">
					<router-link :to="{ name: 'mi-cuenta' }">
						<!-- <span>{{ this.$store.state.usuarioNombre }}</span> -->
						<span>{{ this.$store.state.usuarioIniciales.toUpperCase() }}</span>
					</router-link>
				</div>
			</div>
		</div>
		<nav class="menu-mobile" :class="{ 'active' : isActiveHambur }">
			<router-link :to="{ name: 'home' }" class="menu-mobile-item">Inicio</router-link>
			<a href="https://nacional.uy/es/media/multimedia/video/hwXDlZtfOvmm8xXixwNHPV3RKscDX4ER" class="menu-mobile-item" target="_blank">¿Cómo funciona?<external-link-icon></external-link-icon></a>
			<router-link :to="{ name: 'espectaculos' }" class="menu-mobile-item">Espectáculos</router-link>
			<router-link :to="{ name: 'paseos-gpc' }" class="menu-mobile-item">Paseo del GPC</router-link>
			<router-link :to="{ name: 'mis-entradas' }" class="menu-mobile-item">Mis entradas</router-link>
			<a href="https://www.nacional.uy/" target="_blank" class="menu-mobile-item">Nacional.uy<external-link-icon></external-link-icon></a>
		</nav>
	</header>
</template>

<script>
	import BurgerButton from 'vue-burger-button'
	import { ExternalLinkIcon, UserIcon } from 'vue-feather-icons'

	export default{
		data: function(){
			return {
				showDropdownUser: false,
				scrollPosition: null,
				urlLoginNacional: process.env.VUE_APP_URL_NACIONALUY_LOGIN
			}
		},
		components: {
			ExternalLinkIcon,
			BurgerButton,
			UserIcon
		},
		methods: {
			updateScroll() {
				this.scrollPosition = window.scrollY
			},
			esconderDropdownUser: function() {
				this.showDropdownUser = false;
			},
			cerrarSesion(){
				this.$store.dispatch('destroyToken')
				.then(response => {
					this.$router.push({ name: 'home' })
					location.reload();
				})
			}
		},
		computed: {
			loggedIn(){
				return this.$store.getters.loggedIn
			},
			headerBlue(){
				if(this.$route.name === 'home' || this.$route.name === 'espectaculo' || this.$route.name === 'mi-cuenta' || this.$route.name === 'mis-amigos' || this.$route.name === 'cortesia'){
					if(this.scrollPosition > 46){
						return true;
					} else {
						return false;
					}
				} else {
					return true;
				}
			},
			isActiveHambur(){
				return this.$store.getters.isMenuOpened
			}
		},
		mounted(){
			window.addEventListener('scroll', this.updateScroll);
			
			// Validar token
			if(this.loggedIn){
				this.$store.dispatch('validarToken', {
					usuarioId: localStorage.getItem('usuario_id')
				})
				.then(response => {})
				.catch(error => {
					this.$store.dispatch('destroyToken')
					window.location.href = process.env.VUE_APP_URL_NACIONALUY;
				})
			} else {
				this.$store.dispatch('destroyToken')
			}
		},
		watch: {
			isActiveHambur (val) {
				if (val) {
					document.documentElement.style.overflow = 'hidden';
				} else {
					document.documentElement.style.overflow = 'auto';
				}
			},
			'$route' () {
				this.$store.dispatch('actualizarMenuOpened', false)
			}
		}
	}
</script>

<style lang="scss">
	// .hamburger-box{
	// 	width: 20px !important;
	// 	height: 20px !important;
	// }

	// .hamburger--slider .hamburger-inner{
	// 	top: 0px !important;
	// }

	.menu-mobile{
		background-color: var(--color-white);
		width: 100%;
		position: absolute;
		top: 56px;
		overflow: hidden;
		overflow-y: auto;
		opacity: 0;
		height: 0px;
		-webkit-transition: height .3s ease, opacity .4s ease;
		transition: height .3s ease, opacity .4s ease;

		&.active{
			padding: 0 24px 50px;
			height: calc(100vh - 56px);
			opacity: 1;
			@include flex(column, flex-start, flex-start);
		}

		.menu-mobile-item{
			@include flex(row, space-between, center);
			min-height: 64px;
			border-bottom: 1px solid var(--color-grey-light);
			width: 100%;
			color: var(--color-dark);
			font-family: var(--font-family-poppins);
			font-size: 15px;
			font-weight: var(--font-weight-bold);
			-webkit-letter-spacing: 0;
			-moz-letter-spacing: 0;
			-ms-letter-spacing: 0;
			letter-spacing: 0;
			line-height: 23px;
			text-transform: uppercase;
			-webkit-text-decoration: none !important;
			text-decoration: none !important;
			position: relative;


			svg{
				width: 22px;
				height: 21px;
				margin-left: 6px;
				position: relative;
				top: -1px;
				opacity: 0.5;
			}

			&:before{
				content: "";
				width: 0;
				height: 4px;
				background-color: var(--color-red);
				position: absolute;
				opacity: 1;
				-webkit-transition: width .3s ease, opacity .3s ease;
				transition: width .3s ease, opacity .3s ease;
				bottom: 0;
				left: 0;
			}

			&.router-link-exact-active{
				&:before{
					width: 96px;
				}
			}
		}
	}
</style>

<style scoped lang="scss">
	header{
		position: -webkit-sticky;
		position: sticky;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 101;
		height: 0;
		transition: opacity .2s;

		.header-container{
			@include flex(row, space-between, center);
			height: 72px;
			-webkit-transition: background-color .2s ease;
			transition: background-color .2s ease;

			.hamburger:focus, .hamburger:hover{
				opacity: 1;
			}

			.hambur-menu{
				display: none;
				padding: 0;
				background-color: var(--color-blue-dark) !important;
				text-decoration: none;
				box-shadow: none;
				outline: none;
				border: 0;
				margin: 0;
				height: 100% !important;
				width: 56px !important;
				position: relative;

				.bar{
					width: 20px !important;
					height: 2px !important;
					background-color: var(--color-white) !important;
				}

				&.burguer-button > .bar:nth-child(1){
					-webkit-transform: translateY(-145%) !important;
					transform: translateY(-145%) !important;
				}

				&.burguer-button.-active > .bar:nth-child(1){
					-webkit-transform: translateY(100%) rotate(45deg) !important;
					transform: translateY(100%) rotate(45deg) !important;
				}

				&.burguer-button > .bar:nth-child(3){
					-webkit-transform: translateY(145%) !important;
					transform: translateY(145%) !important;
				}

				&.burguer-button.-active > .bar:nth-child(3){
					-webkit-transform: translateY(-100%) rotate(-45deg) !important;
					transform: translateY(-100%) rotate(-45deg) !important;
				}
			}

			.logo{
				padding: 0 32px;
				background-color: var(--color-blue-dark);
				@include flex(row, center, center);
				text-decoration: none;
				box-shadow: none;
				outline: none;
				border: 0;
				margin: 0;
				height: 100%;

				img{
					width: 52px;
					height: 52px;
					object-fit: contain;
					object-position: center;
					-webkit-transition: width .2s ease, height .2s ease;
					transition: width .2s ease, height .2s ease;
				}

				span{
					font-weight: var(--font-weight-bold);
					color: var(--color-white);
					font-family: var(--font-family-poppins);
					font-size: 16px;
					-webkit-letter-spacing: 0;
					-moz-letter-spacing: 0;
					-ms-letter-spacing: 0;
					letter-spacing: 0;
					line-height: 18px;
					text-transform: uppercase;
					margin-left: 12px;
					max-width: 130px;
				}
			}

			.menu{
				-webkit-flex: 1;
				-ms-flex: 1;
				flex: 1;
				display: -webkit-box;
				display: -webkit-flex;
				display: -ms-flexbox;
				display: flex;
				-webkit-flex-direction: row;
				-ms-flex-direction: row;
				flex-direction: row;
				height: 100%;

				.menu-item{
					a{
						font-size: 16px;
						color: var(--color-white);
						line-height: 25px;
						padding: 0 0 0 24px;
						height: 100%;
						font-family: var(--font-family-poppins);
						font-weight: var(--font-weight-bold);
						@include flex(row, center, center);
						-webkit-letter-spacing: 0;
						-moz-letter-spacing: 0;
						-ms-letter-spacing: 0;
						letter-spacing: 0;
						text-transform: uppercase;
						text-decoration: none;
						position: relative;

						&:before{
							content: "";
							width: 0;
							height: 4px;
							background-color: var(--color-red);
							position: absolute;
							opacity: 0;
							top: 0;
							left: 24px;
							-webkit-transition: width .3s ease, opacity .3s ease;
							transition: width .3s ease, opacity .3s ease;
						}

						&.router-link-exact-active{
							opacity: 1;

							&:before{
								width: calc(100% - 24px);
								opacity: 1;
							}
						}

						svg{
							margin-left: 8px;
							opacity: 0.5;
							width: 21px;
							height: auto;
							margin-top: -3px;
						}
					}
				}
			}

			.user-menu{
				height: 100%;
				@include flex(row, center, center);

				.user-menu-item{
					height: 100%;
					@include flex(row, center, center);

					a{
						@include flex(row, center, center);
						padding: 0 32px;
						height: 100%;
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
						font-weight: var(--font-weight-bold);
						position: relative;
						cursor: pointer;
						background-color: var(--color-red);
						color: var(--color-white);
						-webkit-transition: background-color .2s ease;
						transition: background-color .2s ease;
						-webkit-letter-spacing: 0;
						-moz-letter-spacing: 0;
						-ms-letter-spacing: 0;
						letter-spacing: 0;
						font-size: 16px;
						-webkit-letter-spacing: 0;
						-moz-letter-spacing: 0;
						-ms-letter-spacing: 0;
						letter-spacing: 0;
						line-height: 25px;
						text-decoration: none;
					}

					&.user-menu-item-cuenta{
						@include flex(row, center, center);

						a{
							width: 72px;
							padding: 0px;

							span{
								width: 48px;
								height: 48px;
								@include flex(row, center, center);
								border-radius: 100%;
								background-color: var(--color-blue-dark);
							}
						}
					}

					&.login-item-mobile{
						display: none;
						width: 56px !important;

						a{
							padding: 0px;
							width: 100%;

							svg{
								width: 20px;
								height: 20px;
								margin: 0;
								stroke-width: 2.5px;
							}
						}
					}
				}
			}

			&:hover{
				background-color: var(--color-blue-dark);
				-webkit-transition: background-color .2s ease-in-out, height .2s ease;
				transition: background-color .2s ease-in-out, height .2s ease;

				.menu a:not(.router-link-exact-active){
					opacity: 0.5;

					&:hover{
						opacity: 1;
					}
				}
			}
		}
	}

	header.header-blue{
		.header-container{
			background-color: var(--color-blue-dark);
			-webkit-transition: background-color .2s ease-in-out, height .2s ease;
			transition: background-color .2s ease-in-out, height .2s ease;
		}
	}


	@media screen and (max-width: 1140px){
		header{
			.header-container{
				height: 56px;

				.hambur-menu{
					@include flex(column, center, center);
				}

				.logo{
					padding: 0;
					background-color: transparent;

					img{
						width: 40px;
						height: 40px;
					}

					span{
						font-size: 14px;
						margin-left: 8px;
					}
				}

				.user-menu {
					.user-menu-item{
						&.user-menu-item-cuenta{
							a{
								width: 56px;
								font-size: 14px;

								span{
									width: 38px;
									height: 38px;
								}
							}
						}

						&.login-item-mobile{
							@include flex(row, center, center);
						}

						&.login-item{
							display: none;
						}
					}
				}
			}
		}
		
		header .header-container .menu{
			display: none !important;
		}
	}

	@media screen and (max-width: 480px){
		header{
			.header-container{
				.logo{
					span{
						display: none;
					}
				}
			}
		}
	}
</style>

<style src="vue-burger-button/dist/vue-burger-button.css" />